// react
import React, { useState, useEffect, useRef } from "react";

// libs
import { Helmet } from "react-helmet-async";
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
  Collapse,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";

// redux
import { connect } from "react-redux";

// services
import {
  deleteEvent,
  getEvents,
  reactivateEvent,
} from "../../utils/services/events";
import { getMe } from "../../utils/services/loginUser";

// utils e hooks
import { formatData } from "../../utils/helpers/files/formatDate";
import useDebounce from "../../utils/hooks/useDebounce";
import { toast } from "react-toastify";

// components
import ModalAddUsers from "./ModalAddUsers";
import ModalNewEvent from "./ModalNewEvent";
import ModalViewEvent from "./ModalViewEvent";
import ModalEditEvent from "./ModalEditEvent";
import Pagination from "../../components/Paginationv3";
import SearchFilters from "../../components/SearchFilters";
import SectionComponent from "../Apps/Personalization/SectionComponent";
import ActionButtonRounded from "../../components/Buttons/ActionButtonRounded";
import DeleteButton from "../../components/Buttons/DeleteButton";
import IconButton from "../../components/Buttons/IconButton";
import LoadingSkelentonTable from "../../components/loadingSkeletonTable";

// imagens
import profileImg from "../../assets/image/profile-img.png";

const columnsFilter = [
  { name: "Nome", value: "title", type: "text" },
  { name: "Data Início", value: "start_date", type: "date" },
  { name: "Data Fim", value: "end_date", type: "date" },
];

function Events(props) {
  // pesquisa
  const [search, setSearch] = useState("");

  // modais
  const [modalAddUsers, setModalAddUsers] = useState(false);
  const [modalNewEvent, setModalNewEvent] = useState(false);
  const [modalViewEvent, setModalViewEvent] = useState(false);
  const [modalEditEvent, setModalEditEvent] = useState(false);

  // deletar evento
  const [confirm_alert, setconfirm_alert] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [deleteEventData, setDeleteEventData] = useState(null);

  // visualizar / editar evento
  const [currentEventSelected, setEventSelected] = useState(null);

  // paginação
  const [currentIndex, setCurrentIndex] = useState(1);

  // lista de eventos e paginação
  const [isLoading, setIsLoading] = useState(false);
  const [eventsList, setEventsList] = useState([]);
  const [countData, setCountData] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const debouncedSearch = useDebounce(search, 300);
  const [activeFilter, setActiveFilter] = useState("title");

  // collapse de filtros e opções mobile
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);

  // reativar evento
  const [disabledEvents, setDisabledEvents] = useState(true);
  const [eventReactive, setEventReactive] = useState({});
  const [confirmReactiveAlert, setConfirmReactiveAlert] = useState(false);
  const [reactiveAlert, setReactiveAlert] = useState(false);

  // perfil do usuário logado
  const [profileId, setProfileId] = useState("");

  const navigate = useNavigate();
  const lastTapRef = useRef({ time: 0, id: null });

  // detecta double-tap em touch (substitui onDoubleClick que não funciona no mobile)
  function handleDoubleTap(event, id, callback) {
    const now = Date.now();
    const last = lastTapRef.current;
    if (last.id === id && now - last.time < 300) {
      callback();
      lastTapRef.current = { time: 0, id: null };
    } else {
      lastTapRef.current = { time: now, id };
    }
  }

  // atualiza o filtro ativo e limpa a busca
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // reativa um evento desativado
  async function reactivateEventFunc() {
    try {
      const res = await reactivateEvent(eventReactive.id);
      if (res.message === "updated") {
        setConfirmReactiveAlert(false);
        setReactiveAlert(true);
        getAllEvents();
      }
    } catch (error) {
      toast.error("Erro ao reativar evento.");
    }
  }

  // deleta o evento selecionado
  async function deleteEventFunc() {
    try {
      const eventData = await deleteEvent(deleteEventData.id);
      if (eventData.message === "EVENTO_DISABLED") {
        getAllEvents();
        setconfirm_alert(false);
        setsuccess_dlg(true);
      }
    } catch (error) {
      toast.error("Erro ao deletar evento.");
    }
  }

  // converte data de dd/mm/aaaa para aaaa-mm-dd para a API
  function reverseDate() {
    return debouncedSearch.split("/").reverse().join("/").replace(/\//g, "-");
  }

  // formata o termo de busca conforme o tipo do filtro ativo
  function treatmentSearch() {
    if (
      columnsFilter.find((item) => item.value === activeFilter)?.type === "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // busca eventos da API com filtros, busca e paginação
  async function getAllEvents() {
    setIsLoading(true);
    try {
      const events = await getEvents({
        offset: currentIndex,
        limit: itemsPerPage,
        search: treatmentSearch(),
        columnSearch: activeFilter,
        activate: disabledEvents,
      });
      setCountData(events.findAllEventsData.count);
      setEventsList(events.findAllEventsData.data);
      props.updateEventsList([...events.findAllEventsData.data]);
    } catch (error) {
      toast.error("Erro ao carregar eventos.");
      setCountData(0);
      setEventsList([]);
    } finally {
      setIsLoading(false);
    }
  }

  // redireciona para a tela de participantes do evento selecionado
  function openEventConfig(event) {
    props.openEvent("6", "PARTICIPANTES");
    props.closeMenuConfig();
    props.closeMenuContracts();
    navigate("/event/participantes", {
      state: { idEvent: event.id, event },
    });
  }

  useEffect(() => {
    getAllEvents();
  }, [currentIndex, itemsPerPage, debouncedSearch, disabledEvents]);

  useEffect(() => {
    props.openEvent("0", "EVENTO");
    getProfile();
  }, []);

  // busca o ID do perfil do usuário logado
  async function getProfile() {
    const res = await getMe();
    if (res?.data?.id) {
      setProfileId(res.data.id);
    }
  }

  return (
    <div>
      <Helmet>
        <title>Eventos | Inteegra Plus</title>
      </Helmet>

      {confirmReactiveAlert && (
        <SweetAlert
          title={`Deseja reativar ${eventReactive.title}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={reactivateEventFunc}
          onCancel={() => setConfirmReactiveAlert(false)}
        />
      )}

      {reactiveAlert && (
        <SweetAlert
          success
          title="Reativado"
          onConfirm={() => setReactiveAlert(false)}
        >
          Evento reativado com sucesso
        </SweetAlert>
      )}

      {confirm_alert && (
        <SweetAlert
          title={`Deseja deletar ${deleteEventData.title}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={deleteEventFunc}
          onCancel={() => setconfirm_alert(false)}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      )}

      {success_dlg && (
        <SweetAlert
          success
          title="Deletado"
          onConfirm={() => setsuccess_dlg(false)}
        >
          Evento deletado
        </SweetAlert>
      )}

      {modalNewEvent && (
        <ModalNewEvent
          isOpen={modalNewEvent}
          toggle={() => setModalNewEvent(!modalNewEvent)}
          getAllEvents={getAllEvents}
        />
      )}
      {modalViewEvent && (
        <ModalViewEvent
          isOpen={modalViewEvent}
          toggle={() => setModalViewEvent(!modalViewEvent)}
          currentEventSelected={currentEventSelected}
        />
      )}
      {modalEditEvent && (
        <ModalEditEvent
          isOpen={modalEditEvent}
          toggle={() => setModalEditEvent(!modalEditEvent)}
          currentEventSelected={currentEventSelected}
          getAllEvents={getAllEvents}
        />
      )}
      {modalAddUsers && (
        <ModalAddUsers
          isOpen={modalAddUsers}
          toggle={() => setModalAddUsers(!modalAddUsers)}
          getAllEvents={getAllEvents}
          eventId={currentEventSelected.id}
        />
      )}

      <Card>
        <div className="bg-primary bg-soft">
          <Row
            id="main-header"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary" style={{ paddingBottom: 10 }}>
                  Bem vindo de volta!
                </h5>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>Esse é o sistema Inteegra Plus.</span>
                  <span>
                    Utilize o menu lateral para acessar todas as funcionalidades
                    disponíveis
                  </span>
                </div>
              </div>
            </Col>
            <Col xs="2" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody>
          <CardTitle>Eventos</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={
                    activeFilter === "start_date" || activeFilter === "end_date"
                      ? "date"
                      : "text"
                  }
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={
                        activeFilter === "start_date" ||
                        activeFilter === "end_date"
                          ? "date"
                          : "text"
                      }
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <ActionButtonRounded
                  onClick={() => setModalNewEvent(true)}
                  title="Criar Evento"
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              <Button
                color="secondary"
                className="btn-rounded waves-effect waves-light events-button-add"
                onClick={() => setDisabledEvents(!disabledEvents)}
              >
                {!disabledEvents
                  ? "Filtrar: Apps Ativos"
                  : "Filtrar: Apps Inativos"}
              </Button>
              <ActionButtonRounded
                onClick={() => setModalNewEvent(true)}
                title="Criar Evento"
                margin={"0 0 0 5px"}
              />
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Eventos</th>
                  <th>Localização</th>
                  <th>Data Inicio</th>
                  <th>Data Fim</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={5} />
                ) : eventsList.map((e) => (
                  <tr
                    key={e.id}
                    onDoubleClick={() => openEventConfig(e)}
                    onTouchStart={() => handleDoubleTap(null, e.id, () => openEventConfig(e))}
                    style={{ cursor: "pointer" }}
                  >
                    <th scope="row">{e.title}</th>
                    <td>
                      {e.eventFormat === "digital"
                        ? "Evento Digital"
                        : e?.localizations[0]?.description}
                    </td>
                    <td>{formatData(e.startDate, "/")}</td>
                    <td>{formatData(e.endDate, "/")}</td>
                    <td>
                      {!disabledEvents ? (
                        <IconButton
                          className="mdi mdi-account-reactivate"
                          action="U"
                          color="green"
                          onClick={() => {
                            setEventReactive(e);
                            setConfirmReactiveAlert(true);
                          }}
                        />
                      ) : (
                        <>
                          <i
                            className="mdi mdi-pencil"
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEventSelected(e);
                              setModalEditEvent(true);
                            }}
                          />{" "}
                          <i
                            className="mdi mdi-eye"
                            style={{
                              color: "blue",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEventSelected(e);
                              setModalViewEvent(true);
                            }}
                          />{" "}
                          <DeleteButton
                            onClick={() => {
                              setDeleteEventData(e);
                              setconfirm_alert(true);
                            }}
                          />
                          {(profileId === process.env.REACT_APP_PMCODE ||
                            profileId ===
                              "f741a40e-e696-420a-a05e-06efbdd2ae20") && (
                            <i
                              className="mdi mdi-account-circle-outline"
                              style={{
                                color: "black",
                                fontSize: 17,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setEventSelected(e);
                                setModalAddUsers(true);
                              }}
                            />
                          )}
                          <i
                            className="mdi mdi-location-enter"
                            style={{
                              color: "blue",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => openEventConfig(e)}
                          />
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div className="bottom-navigation" style={{ justifyContent: "end" }}>
        <Pagination
          data={eventsList}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { state };
}

function mapDispatchToProps(dispatch) {
  return {
    updateEventsList: (data) => {
      return dispatch({ type: "UPDATE_EVENT_LIST", data });
    },
    closeMenuConfig: () => {
      return dispatch({ type: "close_menuConfig" });
    },
    closeMenuContracts: () => {
      return dispatch({ type: "CLOSE_MENU_CONTRACTS" });
    },
    openEvent: (data, activeScreenName = null) => {
      return dispatch({ type: "OPEN_EVENT_MENU", data, activeScreenName });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Events);
